/**
 * Feature flags globales de frontend.
 * Controlan disponibilidad de funcionalidades sin tocar backend.
 */
export const FEATURES = {
  PAYMENTS_ENABLED: false,
  /**
   * Paddle Checkout (overlay) en /app/upgrade — requiere VITE_PADDLE_* en .env
   * OFF: flujo previo (createSubscription / upgradeToPro) sin Paddle.
   */
  FEATURE_PADDLE_CHECKOUT_V1: import.meta.env.VITE_FEATURE_PADDLE_CHECKOUT_V1 === 'true',
  /** Si false, no se muestran importes en planes (las claves i18n siguen definidas). */
  SHOW_PLAN_PRICES_IN_UI: false,
  /**
   * Estados de mensaje (tildes en burbuja y en lista de contactos).
   * Activo por defecto; desactivar con `VITE_FEATURE_MESSAGE_STATUS_V1=false` en .env.
   */
  FEATURE_MESSAGE_STATUS_V1: import.meta.env.VITE_FEATURE_MESSAGE_STATUS_V1 !== 'false',
};

